import { GraduationCap } from '@phosphor-icons/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { hapticsImpactLight } from '../utils/haptics';
import {
  DUT_COURSES_PATH,
  useIsDutCoursesNavActive,
  useHasNursingCourses,
} from './nursingCourses';

/**
 * mcgraw-hill (ORA-1261, ORA-1268): Courses, below Dashboard, in the Nursing
 * vertical only. Active on the Courses page and on the Dashboard while the course is
 * the active exam (the Dashboard item steps back then).
 */
export const DutCoursesNavItem = ({ iconsOnly }: { iconsOnly: boolean }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const hasCourses = useHasNursingCourses();
  const isActive = useIsDutCoursesNavActive(pathname);

  if (!hasCourses) return null;

  return (
    <button
      className={`navbar_options_option ${isActive ? 'active' : ''}`}
      onClick={() => {
        hapticsImpactLight();
        navigate(DUT_COURSES_PATH);
      }}
      aria-label="Navigate to Courses"
      aria-current={isActive ? 'page' : undefined}
      tabIndex={iconsOnly ? -1 : 0}
      type="button"
    >
      <GraduationCap
        size={24}
        weight={isActive ? 'fill' : 'regular'}
        aria-hidden="true"
      />
      <span>Courses</span>
    </button>
  );
};
